export default __webpack_public_path__ + "static/media/Groupe 8935.d7740355.svg";